import { redirect, type RouteObject } from 'react-router'

import { ddePaths } from '@/router/DDEPaths'
import { streamingPaths } from '@/router/StreamingPaths'
import { LoginView } from '@/views/LoginView'
import { NotFoundView } from '@/views/NotFoundView'
import { ProtectedLayout } from '@/views/ProtectedLayout'

import { ROUTE_URL } from './constants'

// Custom route labels for the breadcrumbs
export const labelMap = {
  monitoringV2: 'Monitoring V2'
}

export const routes: RouteObject[] = [
  {
    id: 'Login',
    path: ROUTE_URL.LOGIN,
    element: <LoginView />
  },
  {
    id: 'Application',
    path: ROUTE_URL.HOME,
    element: <ProtectedLayout />,
    children: [
      {
        index: true,
        loader: () => redirect(ROUTE_URL.OPERATORS.DEFAULT)
      },
      ...streamingPaths,
      ...ddePaths,
      { path: '*', element: <NotFoundView /> }
    ]
  },
  { path: '*', element: <NotFoundView /> }
]

const [, ...parsedRoutes] = routes[1]?.children as RouteObject[]

export const menu = parsedRoutes
